
export const SystemLogType = {

    EMAIL_CREATE_TASK   : 2,
    EMAIL_REPLY         : 4

// INCOMING_EMAIL      = 1 # not used at the moment
// EMAIL_CREATE_TASK   = 2 # create task via email
// EMAIL_BOUNCE        = 3 # used but no records found ...
// EMAIL_REPLY         = 4 # i think it's reply via email to a task


}